import { render, staticRenderFns } from "./TagBall.vue?vue&type=template&id=0e44a9b0&scoped=true&"
import script from "./TagBall.vue?vue&type=script&lang=js&"
export * from "./TagBall.vue?vue&type=script&lang=js&"
import style0 from "./TagBall.vue?vue&type=style&index=0&id=0e44a9b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e44a9b0",
  null
  
)

export default component.exports